<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 10.4706V8.47061C20.9996 8.11988 20.9071 7.77542 20.7315 7.47177C20.556 7.16812 20.3037 6.91597 20 6.74061L13 2.74061C12.696 2.56507 12.3511 2.47266 12 2.47266C11.6489 2.47266 11.304 2.56507 11 2.74061L4 6.74061C3.69626 6.91597 3.44398 7.16812 3.26846 7.47177C3.09294 7.77542 3.00036 8.11988 3 8.47061V16.4706C3.00036 16.8213 3.09294 17.1658 3.26846 17.4694C3.44398 17.7731 3.69626 18.0252 4 18.2006L11 22.2006C11.304 22.3761 11.6489 22.4686 12 22.4686C12.3511 22.4686 12.696 22.3761 13 22.2006L15 21.0606" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.5 4.7406L16.5 9.8906" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.29 7.47058L12 12.4706L20.71 7.47058" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 22.4706V12.4706" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18.5 18.4706C19.8807 18.4706 21 17.3513 21 15.9706C21 14.5899 19.8807 13.4706 18.5 13.4706C17.1193 13.4706 16 14.5899 16 15.9706C16 17.3513 17.1193 18.4706 18.5 18.4706Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20.27 17.7406L22 19.4706" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#78829D',
      required: false,
    },
  },
};
</script>
